
  import { defineComponent } from 'vue';

  import Tooltip from '@/common/ui/Tooltip.vue';

  export default defineComponent({
    name: 'SumTooltip',
    components: { Tooltip },
  });
